import BaseBarSeries from "./private/BaseBarSeries.js";
import AnimatedBars from "./private/AnimatedBars.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default function AnimatedBarSeries(_ref) {
  let {
    colorAccessor,
    ...props
  } = _ref;
  return /*#__PURE__*/_jsx(BaseBarSeries, {
    ...props,
    colorAccessor: colorAccessor,
    BarsComponent: AnimatedBars
  });
}